import {View} from 'MWC';
import tpl from './templates/interactive';
import {apiback} from '../../../config';
import {Sync} from 'MWComponents';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
        this.widgetsHelper.getWidgets.call(this);
        return this;
    }

    static displayName = 'HappyATB';
}
